<template>
    <wire-frame-gdb>
        <template v-slot:top-main>
            <v-btn v-if="hasLinksPerm.value" :to="{name: 'rm-links'}" tile>Links</v-btn>
            <v-btn v-if="hasCadernoFormandoPerm.value" :to="{name: 'rm-caderno-formandos'}" tile>Caderno Formandos</v-btn>
            <v-btn v-if="hasCadernoConcluintesPerm.value" :to="{name: 'rm-caderno-concluintes'}" tile>Caderno Concluintes</v-btn>
            <v-btn v-if="hasAtivaAlunosPerm.value" :to="{name: 'rm-ativa-alunos'}" tile>Ativação Alunos</v-btn>
            <v-btn v-if="hasFotoAlunosPerm.value" :to="{name: 'rm-foto-alunos'}" tile>Foto Alunos</v-btn>
            <v-btn v-if="hasEnturmarPerm.value" :to="{name: 'rm-enturmar'}" tile>Enturmar</v-btn>
            <v-btn v-if="hasAtualizaLancamentosPerm.value" :to="{name: 'rm-atualizar-data-lancamentos'}" tile>Data Lançamentos</v-btn>
            <v-btn v-if="hasAtualizaNFReijeitada.value" :to="{name: 'rm-atualizar-nf-rejeitada'}" tile>NFs Pendentes/Rejeitada</v-btn>
            <v-btn v-if="hasMigracaoBolsas.value" :to="{name: 'rm-migracao-bolsas'}" tile>Migração de Bolsas</v-btn>
            <v-btn v-if="hasAtualizaParcelaInicialPerm.value" :to="{name: 'rm-atualiza-parcela'}" tile>Atualizar Parcela Inicial</v-btn>
            <v-btn v-if="hasProUni50Perm.value" :to="{name: 'rm-prouni-complementar'}" tile>ProUni Complementar</v-btn>
            <v-divider class="my-2"></v-divider>
        </template>
    </wire-frame-gdb>
</template>
<script setup>
import { ref, computed } from 'vue';
import  { useRouter } from 'vue-router';
const router = useRouter();
const hasLinksPerm = ref(false)
const hasCadernoFormandoPerm = ref(false)
const hasCadernoConcluintesPerm = ref(false)
const hasAtivaAlunosPerm = ref(false)
const hasFotoAlunosPerm = ref(false)
const hasEnturmarPerm = ref(false)
const hasAtualizaLancamentosPerm = ref(false)
const hasAtualizaNFReijeitada = ref(false)
const hasMigracaoBolsas = ref(false)
const hasProUni50Perm = ref(false)
const hasAtualizaParcelaInicialPerm = ref(false)

hasLinksPerm.value = computed(() => router.resolve({name: 'rm-links'}).meta.has_perm())
hasCadernoFormandoPerm.value = computed(() => router.resolve({name: 'rm-caderno-formandos'}).meta.has_perm())
hasCadernoConcluintesPerm.value = computed(() => router.resolve({name: 'rm-caderno-concluintes'}).meta.has_perm())
hasAtivaAlunosPerm.value = computed(() => router.resolve({name: 'rm-ativa-alunos'}).meta.has_perm())
hasFotoAlunosPerm.value = computed(() => router.resolve({name: 'rm-foto-alunos'}).meta.has_perm())
hasEnturmarPerm.value = computed(() => router.resolve({name: 'rm-enturmar'}).meta.has_perm())
hasAtualizaLancamentosPerm.value = computed(() => router.resolve({name: 'rm-atualizar-data-lancamentos'}).meta.has_perm())
hasAtualizaNFReijeitada.value = computed(() => router.resolve({name: 'rm-atualizar-nf-rejeitada'}).meta.has_perm())
hasMigracaoBolsas.value = computed(() => router.resolve({name: 'rm-migracao-bolsas'}).meta.has_perm())
hasProUni50Perm.value = computed(() => router.resolve({name: 'rm-prouni-complementar'}).meta.has_perm())
hasAtualizaParcelaInicialPerm.value = computed(() => router.resolve({name: 'rm-atualiza-parcela'}).meta.has_perm())
</script>